// Videos picked before the piece existed: the manual page creates the draft, hands them over
// and opens the piece, whose card uploads them (with its progress) once mounted.
const pending = new Map();

export const handOffVideos = (pieceId, adaptationId, files) =>
  pending.set(String(pieceId), { adaptationId, files });

export const takeHandedOffVideos = (pieceId) => {
  const key = String(pieceId);
  const handoff = pending.get(key) || null;
  pending.delete(key);
  return handoff;
};
